import API from "../api";
import { Languages } from "../models/languages";
import { UpdateRecord } from "../pages/private/Shared/Settings/Configurations/General/Languages";

import { AxiosResponse } from "axios";
import { LanguagePrefix } from "../types";
import BaseService from "./_base.service";

const endpoint = "languages";

const LanguagesService = {
  ...BaseService<Languages | UpdateRecord>({ endpoint }),
  async getAllPrefixes(): Promise<AxiosResponse<LanguagePrefix[]>> {
    return await API.get(`/${endpoint}/prefix`);
  },
};

export default LanguagesService;
